// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react';
import {
  AbroadPackageModel,
  IsBankOrByUse,
  lobyTabsEnum,
  MatchType,
  PackageOrigin,
  PackageType,
  SupportedSocialMediaApplications,
  UnitMeasureCodeOptionsFeature,
} from '../Models/AbroadPackageModels';
import AbroadStateInclude from './AbroadStateInclude';
import ImportantPart from './ImportantPart';
import AbroadDifferentTarif from './AbroadDifferentTarif';
import CountryPopUp from './../../PackageExists/PopUps/CountryPopUp';
import LocalPopupContainer from '../../LocalPopup/LocalPopupContainer.js';
import WarningMessageComponent from '../../../CellcomAbroadLobbyBlock/Shared/Components/Warning/WarningMessageComponent.js';
import '../Sass/AbroadPackage.scss';
import { isMobile } from 'react-device-detect';
import { getImageSrc } from 'app/utilities/ImageProps';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import { gaEvent } from '../../../../../utilities/analytics/tracking.js';
import constants from '../../../../../utilities/analytics/constants.js';
import { useInView } from 'react-intersection-observer';
import AbroadTooltip from './Tooltip/AbroadTooltip';
import Config from '../../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import { prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import AttentionIcon from './Warning/icons/attention/attention.png';
import {getDataUsageDisplay} from '../../cellcomAbroadUtilities';
import { formatPackageDurationLabel } from '../../cellcomAbroadUtilities';
import Image from 'app/Components/Shared/Image/image';
interface AbroadPackageClientProps {
  context?: IEpiserverContext;
  packageData: AbroadPackageModel;
  orderEvent: Function;
  supportedApps?: SupportedSocialMediaApplications[];
  isSearchOrPopular?: PackageOrigin;
  isPrivateOrBusiness?: lobyTabsEnum;
  isSeparatedSale?: boolean;
  viewWithoutPurchaseStatus?: boolean;
  selectedCountriesCount?: number;
}

const AbroadPackageClient = ({
  packageData,
  orderEvent,
  supportedApps,
  context,
  isSearchOrPopular,
  isPrivateOrBusiness,
  viewWithoutPurchaseStatus,
  isSeparatedSale,
  selectedCountriesCount,
}: AbroadPackageClientProps) => {
  const [displayStateInclude, setDisplayStateInclude] = useState(false);
  const [displayImportantPart, setDisplayImportantPart] = useState(false);
  const [displayTarif, setDisplayTarif] = useState(false);
  const [displaySearchTarifByCountry, setDisplaySearchTarifByCountry] = useState(false);
  const [displayCountryWithCommatByUse, setDisplayCountryWithCommatByUse] = useState(false);
  const refSignPlus = useRef<HTMLSpanElement>();

  const { ref, inView, entry } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView && isSeparatedSale) {
      const { category, eventType, eventParams } = constants.SEPARATED_PACKAGESHOWN_SHOW;
      gaEvent(category, eventType, packageData.socCode);
    }
  }, [inView]);

  useEffect(() => {
    const onBodyClick = (event) => {
      if (refSignPlus?.current?.contains(event.target)) {
        return;
      }
      setDisplayCountryWithCommatByUse(false);
    };

    document.body.addEventListener('click', onBodyClick);

    return () => {
      document.body.removeEventListener('click', onBodyClick);
    };
  }, []);

  const showBusinessTerms = async () => {
    const url = `${Config.termsUrl}?socCode=${packageData.socCode}`;
    let win = window.open(url, '_blank');
    win.focus();
  };

  const openAgreementPDF = async () => {
    prepareUrl(packageData.policiesEpi, EpiContext);
  };
  const handleClickStatesInclude = (event: React.MouseEvent<HTMLDivElement>) => {
    setDisplayStateInclude(!displayStateInclude);

    if (!displayStateInclude) {
      if (isPrivateOrBusiness === lobyTabsEnum.PRIVATE) {
        if (isSearchOrPopular === PackageOrigin.POPULAR) {
          const { category, eventType, eventParams } = constants.ABROAD_LOBBY_POPULAR_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_PRIVATE;
          gaEvent(category, eventType, eventParams);
        }
        if (isSearchOrPopular === PackageOrigin.SEARCH) {
          const { category, eventType, eventParams } = constants.ABROAD_LOBBY_SEARCHED_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_PRIVATE;
          gaEvent(category, eventType, eventParams);
        }
      }
      if (isPrivateOrBusiness === lobyTabsEnum.BUSINESSACCOUNT) {
        if (isSearchOrPopular === PackageOrigin.POPULAR) {
          if (isSeparatedSale) {
            const { category, eventType, eventParams } = constants.SEPARATED_SUPPORTEDCOUNTRIESSEARCH_CLICK;
            gaEvent(category, eventType, eventParams);
          } else {
            const { category, eventType, eventParams } = constants.ABROAD_LOBBY_POPULAR_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_BUSINESS;
            gaEvent(category, eventType, eventParams);
          }
        }
        if (isSearchOrPopular === PackageOrigin.SEARCH) {
          if (isSeparatedSale) {
            const { category, eventType, eventParams } = constants.SEPARATED_SUPPORTEDCOUNTRIES_CLICK;
            gaEvent(category, eventType, eventParams);
          } else {
            const { category, eventType, eventParams } = constants.ABROAD_LOBBY_SEARCHED_SHOW_SUPPORTED_COUNTRIES_BUTTON_IS_CLICKED_BUSINESS;
            gaEvent(category, eventType, eventParams);
          }
        }
      }
    }
  };

  const handleClickImportantPart = (event: React.MouseEvent<HTMLDivElement>) => {
    setDisplayImportantPart(!displayImportantPart);
    if (!displayImportantPart) {
      if (isPrivateOrBusiness === lobyTabsEnum.PRIVATE) {
        if (isSearchOrPopular === PackageOrigin.POPULAR) {
          const { category, eventType, eventParams } = constants.ABROAD_LOBBY_POPULAR_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_PRIVATE;
          gaEvent(category, eventType, eventParams);
        }
        if (isSearchOrPopular === PackageOrigin.SEARCH) {
          const { category, eventType, eventParams } = constants.ABROAD_LOBBY_SEARCHED_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_PRIVATE;
          gaEvent(category, eventType, eventParams);
        }
      }

      if (isPrivateOrBusiness === lobyTabsEnum.BUSINESSACCOUNT) {
        if (isSearchOrPopular === PackageOrigin.POPULAR) {
          if (isSeparatedSale) {
            const { category, eventType, eventParams } = constants.SEPARATED_IMPORTANTTOKNOWSEARCH_CLICK;
            gaEvent(category, eventType, eventParams);
          } else {
            const { category, eventType, eventParams } = constants.ABROAD_LOBBY_POPULAR_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_BUSINESS;
            gaEvent(category, eventType, eventParams);
          }
        }
        if (isSearchOrPopular === PackageOrigin.SEARCH) {
          if (isSeparatedSale) {
            const { category, eventType, eventParams } = constants.SEPARATED_IMPORTANTTOKNOW_CLICK;
            gaEvent(category, eventType, eventParams);
          } else {
            const { category, eventType, eventParams } = constants.ABROAD_LOBBY_SEARCHED_IMPORTANT_TO_KNOW_BUTTON_IS_CLICKED_BUSINESS;
            gaEvent(category, eventType, eventParams);
          }
        }
      }
    }
  };
  const startCard = () => {
    return (
      <div className='abroad-package-client__start-card'>
        {headerRendering()}
        {packageData?.isBankOrByUse === IsBankOrByUse.ByUse ? centerStateByUse() : null}
        {packageData?.isBankOrByUse === IsBankOrByUse.Bank ? filterRenderingBank() : null}
        {packageData?.isBankOrByUse === IsBankOrByUse.ByUse ? detailsRenderingByUse() : null}
      </div>
    );
  };

  const stateRightFormatByUse = () => {
    let countryList = packageData?.packageDetailsList[0]?.countrySupportedList?.map((x, i) => {
      return x.countryHebName;
    });

    let countryListSorted = [...countryList]?.sort((a, b) => a.length - b.length);
    let countryListSortedCopy = [...countryListSorted];
    let countryListSortedIfNotTooMany = [...countryListSorted];
    if (countryListSortedIfNotTooMany.length > 0) countryListSortedIfNotTooMany[0] = `ב${countryListSortedIfNotTooMany[0]}`;

    if (countryListSorted.length > 0) countryListSorted[0] = `ב${countryListSorted[0]}`;

    let countryWithCommat: string[] = [];
    let tooMuch = false;

    let restLineOne = 30;

    for (let i = 0; i < countryListSorted.length; i++) {
      countryWithCommat.push(countryListSorted[i]);
      restLineOne = 30 - countryWithCommat?.join(', ').length;

      if (restLineOne < 0) {
        countryWithCommat[countryWithCommat.length - 1] = `+ ${countryWithCommat.length - i}`;
        tooMuch = true;
        break;
      }
    }

    if (tooMuch) {
      return (
        <div className='abroad-package-client__centerState--oneGroupState__content'>
          {countryWithCommat?.map((c, i) => {
            if (i !== countryWithCommat.length - 1 && i !== countryWithCommat.length - 2) return <span key={c}>{c + ', '}</span>;
            else if (i === countryWithCommat.length - 2) return <span key={c}>{c + ' '}</span>;
            else
              return (
                <span key={c}>
                  <span
                    className='abroad-package-client__centerState--oneGroupState__content__signPlus'
                    ref={refSignPlus}
                    onClick={() => setDisplayCountryWithCommatByUse(!displayCountryWithCommatByUse)}>
                    {countryWithCommat[countryWithCommat.length - 1]}
                  </span>
                  {displayCountryWithCommatByUse && toolTipCountrySupportedByUse(countryListSortedCopy)}
                </span>
              );
          })}
        </div>
      );
    }

    return <div className='abroad-package-client__centerState--oneGroupState__content'>{countryListSortedIfNotTooMany?.join(', ')}</div>;
  };
  const toolTipCountrySupportedByUse = (countryList: string[]) => {
    if (refSignPlus.current) {
      return (
        <div className='abroad-package-client__centerState--oneGroupState__toolTip'>
          <div className='abroad-package-client__centerState--oneGroupState__toolTip__text'>
            {countryList?.map((x, i) => {
              if (i !== countryList?.length - 1) {
                return <span key={i}>{x}, </span>;
              } else return <span key={i}>{x}</span>;
            })}
          </div>
          <span
            className='abroad-package-client__centerState--oneGroupState__toolTip__arrow'
            style={{
              left: `${refSignPlus.current.offsetLeft + refSignPlus.current.offsetWidth / 2 - 6}px`,
            }}></span>
        </div>
      );
    }
  };
  const centerStateByUse = () => {
    if (packageData?.packageDetailsList?.length == 1) {
      return (
        <div className={`abroad-package-client__centerState--oneGroupState`}>
          <div className='abroad-package-client__centerState--oneGroupState__title'>{
            packageData?.steppedPerDay == true && packageData?.type.toLowerCase() === "data" ?
              "גלישה יומית" : " חיוב לפי שימוש"
          }</div>
          {stateRightFormatByUse()}
        </div>
      );
    }
    return (
      <div className='abroad-package-client__centerState--manyGroupState'>
        <div className='abroad-package-client__centerState--manyGroupState__title'>חיוב לפי שימוש</div>
        <div className='abroad-package-client__centerState--manyGroupState__content'>
          <div className='abroad-package-client__centerState--manyGroupState__content__up'>
            שימו לב, במסלול זה התעריפים משתנים לפי מדינה
          </div>
          <div
            className='abroad-package-client__centerState--manyGroupState__content__down'
            onClick={() =>
              viewWithoutPurchaseStatus && selectedCountriesCount == 0
                ? setDisplaySearchTarifByCountry(!displaySearchTarifByCountry)
                : setDisplayTarif(!displayTarif)
            }>
            <span>לצפייה בתעריפים</span>
            <span>{`>`}</span>
          </div>
        </div>
      </div>
    );
  };

  const labelRendering = () => {
    return (
      <div className='abroad-package-client__label'>
        <span className='abroad-package-client__label--text'>{packageData?.labelEpi}</span>
      </div>
    );
  };
  const headerRendering = () => {
    let durText = 'לטיסה אחת, ללא הגבלת זמן';
    if (
      packageData?.isBankOrByUse === IsBankOrByUse.Bank ||
      (packageData?.isBankOrByUse === IsBankOrByUse.ByUse && packageData?.packageDuration != null && packageData?.packageDuration > 0)
    ) {
      durText = `חבילה ל-${formatPackageDurationLabel(packageData?.packageDuration, packageData?.packageDurationUnit)}`;
    } else if (
      packageData?.numberOfTripAllowed == null ||
      packageData?.numberOfTripAllowed == undefined ||
      packageData?.numberOfTripAllowed == -1
    ) {
      durText = 'ללא הגבלת זמן';
    } else if (packageData?.numberOfTripAllowed != 1) {
      durText = `ל-${packageData?.numberOfTripAllowed} טיסות, ללא הגבלת זמן`;
    }
    return (
      <>
        {packageData?.labelEpi ? labelRendering() : null}
        <div className='abroad-package-client__title'>{packageData?.titleEpi}</div>
        <div className='abroad-package-client__separator'></div>
        <div className='abroad-package-client__duration'>{durText}</div>
      </>
    );
  };

  const detailsRenderingByUse = () => {
    if (packageData?.packageDetailsList?.length === 1) {
      return <div className={`abroad-package-client__details--byUse`}>{filterRenderingByUse()}</div>;
    }
  };

  const filterRenderingByUse = () => {
    switch (packageData?.type) {
      case PackageType.VoiceSmsData: {
        return (
          <>
            {phoneRenderingByUse('three-column')}
            <div className='abroad-package-client__details--byUse__separator--big'></div>
            {smsRenderingByUse('three-column')}
            <div className='abroad-package-client__details--byUse__separator--big'></div>
            {dataRenderingByUse('three-column')}
          </>
        );
      }
      case PackageType.VoiceAndSmsData: {
        return (
          <>
            {phoneAndSmsRenderingByUse()}
            <div className='abroad-package-client__details--byUse__separator--big'></div>
            {dataRenderingByUse()}
          </>
        );
      }
      case PackageType.VoiceAndSms: {
        return <>{phoneAndSmsRenderingByUse()}</>;
      }
      case PackageType.VoiceSms: {
        return (
          <>
            {phoneRenderingByUse()}
            <div className='abroad-package-client__details--byUse__separator--small'></div>
            {smsRenderingByUse()}
          </>
        );
      }
      case PackageType.Data: {
        return <>{dataRenderingByUse()}</>;
      }
      default:
        return null;
    }
  };

  const dataRenderingByUse = (nameClass?: string, containerNameClass?: string) => {
    const details = packageData?.packageDetailsList[0];
    const dataDisplay = getDataUsageDisplay(details?.data);
    return (
      <div className={`abroad-package-client__details--byUse__container ${containerNameClass != null ? containerNameClass : ``}`}>
        <span>
          <div className='abroad-package-client__details--byUse__container__title'>גלישה</div>
          <div className={`abroad-package-client__details--byUse__container__content ${nameClass != null ? nameClass : ``}`}>
            <span>{dataDisplay.value}</span>
            <span>{dataDisplay.unit}</span>
            <br />
            {!(
              packageData?.steppedPerDay === true && packageData?.type.toLowerCase() === "data"
            ) && (
              <>
                ב - {shekelOrAgourot(details.data.priceByUsage)}
                {details.data.unit === UnitMeasureCodeOptionsFeature.PerDay ? ' ליום' : ''}
              </>
            )}
       
          </div>
        </span>
      </div>
    );
  };

  const smsRenderingByUse = (nameClass?: string, containerNameClass?: string) => {
    const details = packageData?.packageDetailsList[0];
    return (
      <div className={`abroad-package-client__details--byUse__container ${containerNameClass != null ? containerNameClass : ``}`}>
        <div className='abroad-package-client__details--byUse__container__title'>הודעות סמס</div>
        <div className={`abroad-package-client__details--byUse__container__content ${nameClass != null ? nameClass : ``}`}>
          {shekelOrAgourot(details.sms.priceByUsage)} להודעה
        </div>
      </div>
    );
  };

  const phoneRenderingByUse = (nameClass?: string, containerNameClass?: string) => {
    const details = packageData?.packageDetailsList[0];
    return (
      <div className={`abroad-package-client__details--byUse__container ${containerNameClass != null ? containerNameClass : ``}`}>
        <div className='abroad-package-client__details--byUse__container__title'>שיחות</div>
        <div className={`abroad-package-client__details--byUse__container__content ${nameClass != null ? nameClass : ``}`}>
          {shekelOrAgourot(details.voice.priceByUsage)} לדקה
        </div>
      </div>
    );
  };

  const phoneAndSmsRenderingByUse = () => {
    const details = packageData?.packageDetailsList[0];
    return (
      <div className='abroad-package-client__details--byUse__container'>
        <div className='abroad-package-client__details--byUse__container__title'>שיחות/הודעות סמס</div>
        <div className='abroad-package-client__details--byUse__container__content'>
          {shekelOrAgourot(details.voice.priceByUsage)} לדקה/הודעה
        </div>
      </div>
    );
  };

  const shekelOrAgourot = (price: number) => {
    if (price >= 1)
      return (
        <>
          <span>{price}</span> ₪
        </>
      );
    else
      return (
        <>
          <span>{price * 100}</span> אג'
        </>
      );
  };

  const addSpaceIfAllSituationAndSecondTag = () => {
    if (
      (packageData?.type === PackageType.VoiceSmsData || packageData?.type === PackageType.VoiceAndSmsData) &&
      packageData?.dataForApp?.hasDataForApp &&
      packageData?.tagTextSecondary
    ) {
      return 'add_space_all_situation_and_tag_secondary';
    }
  };
  const filterRenderingBank = () => {
    switch (packageData?.type) {
      case PackageType.VoiceSmsData: {
        return voiceAndSmsDataTypeRenderingBank();
      }
      case PackageType.VoiceAndSmsData: {
        return voiceAndSmsDataTypeRenderingBank();
      }
      case PackageType.VoiceAndSms: {
        return voiceAndSmsTypeRenderingBank();
      }
      case PackageType.VoiceSms: {
        return voiceAndSmsTypeRenderingBank();
      }
      case PackageType.Data: {
        return dataTypeRenderingBank();
      }
      case PackageType.Voice: {
        return voiceOnlyRenderingBank();
      }
      case PackageType.Sms: {
        return smsOnlyRenderingBank();
      }
      default:
        return null;
    }
  };

  const voiceAndSmsDataTypeRenderingBank = () => {
    return (
      <>
        {dataRenderingBank()}
        {detailsPhoneSmsRenderingBank()}
      </>
    );
  };
  const voiceAndSmsTypeRenderingBank = () => {
    return <>{detailsPhoneSmsRenderingBank()}</>;
  };

  const dataTypeRenderingBank = () => {
    return (
      <>
        {dataRenderingBank()}
        {renderingNoVoiceNoSMS()}
      </>
    );
  };

  const renderingNoVoiceNoSMS = () => {
    return (
      <div className={`abroad-package-client__details_noVoice_noSMS `}>
        <div>ללא שיחות</div>
        <div className='abroad-package-client__details_noVoice_noSMS_separator'></div>
        <div>ללא הודעות סמס</div>
      </div>
    );
  };

  const dataRenderingBank = () => {
    if (packageData?.packageDetailsList[0].data.isUnlimited)
      return <div className={`abroad-package-client__data--bank-unlimited ${packageData.type} `}>{dataUnlimitedRenderingBank()}</div>;
    else
      return (
        <>
          <div className={`abroad-package-client__data--bank ${packageData?.type}`}>{dataValueBank()}</div>
          {packageData?.dataForApp?.hasDataForApp ? dataUnlimitedAppBank() : null}
        </>
      );
  };
  const voiceOnlyRenderingBank = () => {
    return (
      <div className={`abroad-package-client__data--bank ${packageData?.type}`}>
        <div>
          <div className='abroad-package-voice-unit'>{packageData?.packageDetailsList[0].voice.value}</div>
          <div className='abroad-package-voice-text'> דקות שיחה</div>
        </div>
      </div>
    );
  };
  const smsOnlyRenderingBank = () => {
    return (
      <div className={`abroad-package-client__data--bank ${packageData?.type}`}>
        <div>
          <div className='abroad-package-sms-unit'>{packageData?.packageDetailsList[0].sms.value}</div>
          <div className='abroad-package-sms-text'>הודעות סמס</div>
        </div>
      </div>
    );
  };

  const dataUnlimitedRenderingBank = () => {
    return (
      <div className='abroad-package-client-data-unlimited'>
        <div className='abroad-package-client-data-unlimited__type'>גלישה</div>
        <div className='abroad-package-client-data-unlimited__value'>ללא הגבלה</div>
      </div>
    );
  };

  const dataValueBank = () => {
    return (
      <>
        {packageData?.packageDetailsList[0].data.value}
        <span className='abroad-package-data-unit'>{packageData?.packageDetailsList[0].data.unit}</span>
      </>
    );
  };

  const renderIconBank = () => {
    let iconTagArray: JSX.Element[] = [];

    for (let i = 0; i < supportedApps?.length; i++) {
      let src = getImageSrc(supportedApps[i]?.appIcon, context);
      iconTagArray.push(
        <Image
          key={supportedApps[i].appName}
          src={src}
          alt={supportedApps[i].appName}
          className='abroad-package-client__data--bank-unlimited-app--icons--item'
        />,
      );
    }

    return iconTagArray;
  };
  const dataUnlimitedAppBank = () => {
    return (
      <div className='abroad-package-client__data--bank-unlimited-app'>
        <div className='abroad-package-client__data--bank-unlimited-app--icons'>{renderIconBank()}</div>
        <div className='abroad-package-client__data--bank-unlimited-app--text'>
          {packageData?.dataForApp?.isUnlimitedDataForApp
            ? `כולל גלישה חופשית באפליקציות נבחרות`
            : `וגם ${packageData?.dataForApp?.valueDataForApp}${packageData?.dataForApp?.unit} גלישה לאפליקציות נבחרות`}
        </div>
      </div>
    );
  };

  const detailsPhoneSmsRenderingBank = () => {
    switch (packageData?.type) {
      case PackageType.VoiceSmsData: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData?.packageDetailsList[0].sms.isUnlimited)
          return (
            <div className={`abroad-package-client__details--bank-unlimited ${packageData.type}`}>{voiceSmsUnlimitedRenderingBank()}</div>
          );
        else
          return (
            <div className={`abroad-package-client__details--bank-regular ${packageData?.type}`}>
              <div className={`abroad-package-client__details--bank-regular-content`}>{voiceRenderingBank()}</div>
              <div className={`abroad-package-client__details--bank-regular-content`}>{smsRenderingBank()}</div>
            </div>
          );
      }
      case PackageType.VoiceAndSmsData: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData?.packageDetailsList[0].sms.isUnlimited)
          return (
            <div className={`abroad-package-client__details--bank-unlimited ${packageData.type}`}>{voiceSmsUnlimitedRenderingBank()}</div>
          );
        else return <div className={`abroad-package-client__details--bank-regular ${packageData?.type}`}>{voiceAndSmsRenderingBank()}</div>;
      }
      case PackageType.VoiceSms: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData?.packageDetailsList[0].sms.isUnlimited)
          return (
            <div className={`abroad-package-client__details--bank-unlimited ${packageData.type}`}>{voiceSmsUnlimitedRenderingBank()}</div>
          );
        else
          return (
            <div className={`abroad-package-client__details--bank-regular ${packageData?.type}`}>
              <div className={`abroad-package-client__details--bank-regular-title`}>שיחות והודעות סמס</div>
              <div className={`abroad-package-client__details--bank-regular-content`}>
                {voiceRenderingBank()}
                {smsRenderingBank()}
              </div>
            </div>
          );
      }

      case PackageType.VoiceAndSms: {
        if (packageData?.packageDetailsList[0].voice.isUnlimited && packageData?.packageDetailsList[0].sms.isUnlimited)
          return (
            <div className={`abroad-package-client__details--bank-unlimited ${packageData.type}`}>{voiceSmsUnlimitedRenderingBank()}</div>
          );
        else return <div className={`abroad-package-client__details--bank-regular ${packageData?.type}`}>{voiceAndSmsRenderingBank()}</div>;
      }

      default: {
        return null;
      }
    }
  };

  const voiceSmsUnlimitedRenderingBank = () => {
    return (
      <div className='abroad-package-voice-sms-unlimited'>
        <div className='abroad-package-voice-sms-unlimited__type'>שיחות והודעות סמס</div>
        <div className='abroad-package-voice-sms-unlimited__value'>ללא הגבלה</div>
      </div>
    );
  };

  const voiceAndSmsRenderingBank = () => {
    return (
      <div className='abroad-package-voice-sms'>
        <div className='abroad-package-voice-sms__type'>שיחות / הודעות סמס</div>
        <div className='abroad-package-voice-sms__value'>
          <span>{packageData?.packageDetailsList[0].voice.value}</span> <span>דקות והודעות</span>
        </div>
      </div>
    );
  };
  const voiceRenderingBank = () => {
    return (
      <div className='abroad-package-voice-sms'>
        <div className='abroad-package-voice-sms__type'>שיחות</div>
        <div className='abroad-package-voice-sms__value'>
          <span>{packageData?.packageDetailsList[0].voice.value}</span>
          <span className='abroad-package-voice-sms--space'>&nbsp;</span>
          <span>דקות</span>
        </div>
      </div>
    );
  };

  const smsRenderingBank = () => {
    return (
      <div className='abroad-package-voice-sms'>
        <div className='abroad-package-voice-sms__type'>הודעות סמס</div>
        <div className='abroad-package-voice-sms__value'>
          <span>{packageData?.packageDetailsList[0].sms.value}</span>
          <span className='abroad-package-voice-sms--space'>&nbsp;</span>

          <span>הודעות</span>
        </div>
      </div>
    );
  };

  const endCard = () => {
    return (
      <div className='abroad-package-client__end-card'>
        {financialDetail()}
        {footer()}
      </div>
    );
  };

  const financialDetail = () => {
    if (packageData?.isBankOrByUse === IsBankOrByUse.Bank) {
      return (
        <div className='abroad-package-client__financial-details--bank'>
          <div className={`abroad-package-client__financial-details--bank--price  ${viewWithoutPurchaseStatus ? 'm-auto' : ''}`}>
            {packageData.tagTextSecondary ? downLabelRendering() : null}
            <div className='abroad-package-client__financial-details--bank--price__real'>
              <span className='abroad-package-client__price-real--bank--container'>
                <span>{packageData.price}</span>
                <span className='abroad-package-client__price-real--bank--container__shekel-symbol'>₪</span>
              </span>
            </div>
            <div className='abroad-package-client__financial-details--bank--price__deleted'>
              <span className='abroad-package-client__price-delete--bank--container'>
                <div>
                  <span>{packageData?.priceDeleted === 0 || !packageData?.priceDeleted ? null : `₪`}</span>
                  <span>{packageData?.priceDeleted === 0 || !packageData?.priceDeleted ? null : packageData.priceDeleted}</span>
                </div>
                <div className='abroad-package-client__financial-details--bank--price--eraser'></div>
              </span>
            </div>
          </div>
          {!viewWithoutPurchaseStatus && (
            <div
              className='abroad-package-client__financial-details--bank--button'
              onClick={() => {
                orderEvent(packageData);
              }}>
              לרכישה
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className='abroad-package-client__financial-details--byUse'>
          <div className={`abroad-package-client__financial-details--byUse__right  ${viewWithoutPurchaseStatus ? 'm-auto' : ''}`}>
            {packageData?.price ? (
              <>
                {packageData.tagTextSecondary ? downLabelRendering() : null}
                <div className='abroad-package-client__financial-details--byUse__right--recurring'>
                  {!packageData.isRecurringPayment ? `+ חיוב חד פעמי` : `+ חיוב חד פעמי`}
                </div>

                <div className='abroad-package-client__financial-details--byUse__right--price-block'>
                  <div className='abroad-package-client__financial-details--byUse__right--price-block__price'>
                    <span>{packageData.price}</span>
                    <span className='abroad-package-client__financial-details--byUse__right--price-block__price__shekel-symbol'>₪</span>
                  </div>
                  <div className='abroad-package-client__financial-details--byUse__right--price-block__price-delete__container'>
                    <div className='abroad-package-client__financial-details--byUse__right--price-block__price-delete__container-in'>
                      <div className='abroad-package-client__financial-details--byUse__right--price-block__price-delete'>
                        <span>{packageData?.priceDeleted === 0 || !packageData?.priceDeleted ? null : `₪`}</span>
                        <span>{packageData?.priceDeleted === 0 || !packageData?.priceDeleted ? null : packageData.priceDeleted}</span>
                        <div className='abroad-package-client__financial-details--byUse__right--price-block__eraser'></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          {!viewWithoutPurchaseStatus && (
            <div
              className='abroad-package-client__financial-details--byUse--button'
              onClick={() => {
                orderEvent(packageData);
              }}>
              לרכישה
            </div>
          )}
        </div>
      );
    }
  };

  const downLabelRendering = () => {
    return (
      <div className='abroad-package-client__financial-details--bank--price__label'>
        <span className='abroad-package-client__financial-details--bank--price__label--text'>{packageData?.tagTextSecondary}</span>
      </div>
    );
  };

  const footer = () => {
    return (
      <div className={'abroad-package-client__footer'}>
        <div
          className={`${packageData?.isBankOrByUse === IsBankOrByUse.ByUse && packageData?.importantInfo.length > 0
              ? 'abroad-package-client__footer--separator'
              : ``
            }${packageData?.isBankOrByUse === IsBankOrByUse.Bank ? 'abroad-package-client__footer--separator' : ``}`}></div>
        <div className='abroad-package-client__footer--content'>
          {packageData?.isBankOrByUse === IsBankOrByUse.Bank ? (
            <div className='abroad-package-client__footer--content--text' onClick={handleClickStatesInclude}>
              מדינות כלולות
              <span className='abroad-package-client__footer--content--text__arrow'>{`>`}</span>
            </div>
          ) : null}
          {packageData?.importantInfo.length > 0 ? (
            <>
              <div className='abroad-package-client__footer--content--text' onClick={handleClickImportantPart}>
                חשוב לדעת
                <span className='abroad-package-client__footer--content--text__arrow'>{`>`}</span>
              </div>
            </>
          ) : (
            <>
              <div
                className='abroad-package-client__footer--content--text'
                onClick={() => (packageData.policiesEpi ? openAgreementPDF() : showBusinessTerms())}>
                {' '}
                חשוב לדעת
                <span className='abroad-package-client__footer--content--text__arrow'>{`>`}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  const TextUnderPackage = () => {
    let textInsideTooltip = packageData?.textInsideTooltipPackage;
    return (
      <div
        className={`abroad-package-client__text-under-package ${packageData?.isSearch && packageData?.matchType !== MatchType.Null && `state-or-country-not-exact`
          }`}>
        <div className='abroad-package-client__text-under-package__star-icon'>
          <Image src={require('../Icons/icon-24-star.svg')} alt='start' />
        </div>
        {packageData?.textUnderPackage ? (
          <div className='abroad-package-client__text-under-package__text'>
            {packageData?.textUnderPackage}
            {textInsideTooltip ? (
              <AbroadTooltip tooltipId={'family-package-tooltip'} onclick={true} tooltipText={textInsideTooltip} />
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };
  const TextUnderPackageStateOrDateNotExact = () => {
    return (
      <div className={`${packageData?.textUnderPackage && `hasTextUnderPackage`}`}>
        <WarningMessageComponent
          packageData={packageData}
          unsupportedCountries={packageData?.countrySearchedButNotSupported}
          isSuitableDates={packageData?.matchType === MatchType.StateNotMatch ? true : false}
        />
      </div>
    );
  };
  return (
    <div className='abroad-package-client__container' ref={ref}>
      <div
        className={`abroad-package-client ${packageData?.textUnderPackage ? 'abroad-package-client__family-shadow' : ''} ${isMobile ? `packageInMobileView` : ``
          }`}>
        {startCard()}
        {endCard()}
        <LocalPopupContainer showPopUp={displayImportantPart} onClose={() => setDisplayImportantPart(!displayImportantPart)}>
          <ImportantPart
            importantInfo={packageData.importantInfo}
            policiesEpi={packageData.policiesEpi}
            showBusinessTerms={showBusinessTerms}
            openAgreementPDF={openAgreementPDF}
          />
        </LocalPopupContainer>
        <LocalPopupContainer showPopUp={displayTarif} onClose={() => setDisplayTarif(!displayTarif)}>
          <AbroadDifferentTarif packageDetailsList={packageData?.packageDetailsList} packageData={packageData} />
        </LocalPopupContainer>
        <LocalPopupContainer
          showPopUp={displaySearchTarifByCountry}
          onClose={() => setDisplaySearchTarifByCountry(!displaySearchTarifByCountry)}>
          <CountryPopUp packageSocCode={packageData?.socCode} />
        </LocalPopupContainer>
        <LocalPopupContainer showPopUp={displayStateInclude} onClose={() => setDisplayStateInclude(!displayStateInclude)}>
          <AbroadStateInclude stateInclude={packageData?.countrySupportedDictionary} />
        </LocalPopupContainer>
      </div>
      {packageData?.textUnderPackage ? (
        <div className='family-container'>{packageData?.textUnderPackage ? TextUnderPackage() : null}</div>
      ) : null}
      {packageData?.isSearch && packageData?.matchType !== MatchType.Null ? TextUnderPackageStateOrDateNotExact() : null}
    </div>
  );
};

export default AbroadPackageClient;
